export const RESET_STATE = 'SETTINGS_RESET_STATE';

export const REQUEST_LOADING = 'SETTINGS_REQUEST_LOADING';
export const REQUEST_SUCCESS = 'SETTINGS_REQUEST_SUCCESS';
export const REQUEST_FAILED = 'SETTINGS_REQUEST_FAILED';
